import { matchers } from "../validate-props";
/**
 * Creates a state-matchine and return an API
 * @param {Function} reducer
 * @param {Object} initState
 * @returns {Object} api with { getState, dispatch, subscribe, unsubscribe };
 */
export default function createStore(reducer, initState) {
    if (!matchers.function(reducer)) return null;
    let state = initState;
    const listeners = new Set();

    /**
     * Returns store state
     * @returns *
     */
    const getState = () => {
        return state;
    };

    /**
     * Call the store reducer providing the
     * current state + action
     * @param {*} action
     */
    const dispatch = (action) => {
        state = reducer(state, action);
        for (const listener of listeners) {
            listener(state);
        }
    };

    /**
     * Callback function to be removed from
     * subscribe list.
     * @param {Function} listener
     */
    const unsubscribe = (listener) => {
        if (typeof listener !== "function") {
            throw new Error("Expected listener to be a Function");
        }
        listeners.delete(listener);
    };

    /**
     * Callback function to be called on every
     * store change
     * @param {Function} listener
     */
    const subscribe = (listener) => {
        if (typeof listener !== "function") {
            throw new Error("Expected listener to be a Function");
        }
        listeners.add(listener);
    };
    // API
    return { getState, dispatch, subscribe, unsubscribe };
}
